/* Saduq Care — product page helpers (complements theme.js) */
(() => {
  'use strict';
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));

  /* Read-more: hide the toggle when the text fits inside the clamp */
  function initClamps(scope) {
    $$('[data-pm-clamp]', scope).forEach((el) => {
      const btn = document.querySelector(`[data-readmore="${el.id}"]`);
      if (!btn) return;
      const check = () => {
        if (el.classList.contains('is-open')) return;
        btn.hidden = el.scrollHeight <= el.clientHeight + 2;
      };
      check();
      if (!el.dataset.pmClampReady) {
        el.dataset.pmClampReady = '1';
        window.addEventListener('resize', check, { passive: true });
        if (document.fonts && document.fonts.ready) document.fonts.ready.then(check);
      }
    });
  }

  /* Variant picker: keep the "Option: value" legend in sync */
  document.addEventListener('change', (e) => {
    const input = e.target.closest('[data-variant-picker] input[data-option-index]');
    if (!input || input.type !== 'radio') return;
    const root = input.closest('[data-variant-picker]');
    $$(`[data-pm-opt-label="${input.dataset.optionIndex}"]`, root).forEach((l) => (l.textContent = input.value));
  });

  /* Before/after: drag anywhere on the image (not only the invisible thumb) */
  function initBA(scope) {
    $$('.pp-ba[data-ba]', scope).forEach((root) => {
      if (root.dataset.pmBaReady) return;
      root.dataset.pmBaReady = '1';
      const range = root.querySelector('input[type=range]');
      if (!range) return;
      let dragging = false;
      const setFrom = (x) => {
        const r = root.getBoundingClientRect();
        const pct = Math.max(0, Math.min(100, ((x - r.left) / r.width) * 100));
        range.value = Math.round(pct);
        range.dispatchEvent(new Event('input', { bubbles: true }));
      };
      range.addEventListener('pointerdown', (e) => {
        dragging = true;
        setFrom(e.clientX);
        if (e.pointerType === 'mouse') range.setPointerCapture(e.pointerId);
      });
      range.addEventListener('pointermove', (e) => { if (dragging) setFrom(e.clientX); });
      const stop = () => (dragging = false);
      range.addEventListener('pointerup', stop);
      range.addEventListener('pointercancel', stop);
    });
  }

  function boot(scope = document) {
    initClamps(scope);
    initBA(scope);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot());
  else boot();
  document.addEventListener('shopify:section:load', (e) => boot(e.target));
})();
